import {
  Box,
  Button as MuiButton,
  Card,
  CardContent,
  Checkbox,
  Divider,
  FormControl,
  FormGroup,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select as MuiSelect,
  TextField as MuiTextField,
  Typography,
  Skeleton,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputAdornment from "@mui/material/InputAdornment";
import { makeStyles } from "@mui/styles";
import { spacing } from "@mui/system";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import styled from "styled-components";
import { getByUuid as getPropertyByUuid } from "../../../modules/property/api/actions";
import { txtBoxDateFormatter } from "../../../setup/helpers";
import {
  put as updateUtilityRiderRate,
  post as createUtilityRiderRate,
  updatePropertyUtilityLocalState,
  getByPropertyId as getPropertyUtility
} from "../api/actions";
import { get as getAllOwners } from "../../owner/api/actions";
import { get as getAllVendors } from "../../vendor/api/actions";
import { UnsubscribeOutlined } from "@mui/icons-material";
import { setSnackbar } from "../../snackbar/api/snackbar";
import { post, put } from "../api/actions";

const TextField = styled(MuiTextField)(spacing);
const Select = styled(MuiSelect)(spacing);
const Button = styled(MuiButton)(spacing);

const normalizeOutageReportedDate = (value) => {
  if (!value) return null;
  const parsed = moment(
    value,
    [moment.ISO_8601, "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm", "YYYY-MM-DD"],
    true
  );
  const fallback = parsed.isValid() ? parsed : moment(value);
  return fallback.isValid() ? fallback.format("YYYY-MM-DD HH:mm:ss") : null;
};

const toDateTimeLocalValue = (value, defaultDateValue) => {
  if (!value || value === defaultDateValue || value === "0000-00-00 00:00:00") {
    return "";
  }
  const parsed = moment.utc(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DDTHH:mm") : "";
};

const PropertyUtilityForm = (props) => {
  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    loadingIcon: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
    },
    selectedDropDownLabel: {
      backgroundColor: "#fffffff",
      borderColor: "#fffffff",
    },
  }));

  const onFieldChange = (event) => {
    const updatedPropertyUtility = {
      ...props.propertyUtilities.data.propertyUtility
    };
    
    const fieldName = event.target.name;
    let fieldValue = event.target.value;

    if (fieldName === "outageReportedDate") {
      setOutageReportedOverride(fieldValue);
    }
    
    if (event.target.type === "number") {
      fieldValue = fieldValue === "" ? null : Number(fieldValue);
    }
    
    updatedPropertyUtility[fieldName] = fieldValue;
    
    props.updatePropertyUtilityLocalState(updatedPropertyUtility);
  };
  const onFieldExit = () => {
    props.updatePropertyUtilityLocalState(
      props.propertyUtilities.data.propertyUtility
    );
  };

  console.log(props, 'props');

  const toggleServiceOuttage = () => {
    const newValue = !serviceOuttage;
    setServiceOuttage(newValue);
    const updatedPropertyUtility = {
      ...props.propertyUtilities.data.propertyUtility,
      serviceOutage: newValue ? 1 : 0
    };
    props.updatePropertyUtilityLocalState(updatedPropertyUtility);
  };

  const toggleActive = () => {
    const newValue = !active;
    setActive(newValue);
    const updatedPropertyUtility = {
      ...props.propertyUtilities.data.propertyUtility,
      active: newValue ? 1 : 0
    };
    props.updatePropertyUtilityLocalState(updatedPropertyUtility);
  };
  const toggleCustomerInitiatedMoveIn = () => {
    const currentValue = props.propertyUtilities.data.propertyUtility.customerInitiatedMoveIns;
    const newValue = (currentValue === 1 || currentValue === true) ? 0 : 1;
    const updatedPropertyUtility = {
      ...props.propertyUtilities.data.propertyUtility,
      customerInitiatedMoveIns: newValue
    };
    props.updatePropertyUtilityLocalState(updatedPropertyUtility);
  };
  const toggleCustomerInitiatedMoveOut = () => {
    const currentValue = props.propertyUtilities.data.propertyUtility.customerInitiatedMoveOuts;
    const newValue = (currentValue === 1 || currentValue === true) ? 0 : 1;
    const updatedPropertyUtility = {
      ...props.propertyUtilities.data.propertyUtility,
      customerInitiatedMoveOuts: newValue
    };
    props.updatePropertyUtilityLocalState(updatedPropertyUtility);
  };

  // Handles vendor drop down
  const [serviceOuttage, setServiceOuttage] = React.useState(
    () => {
      const serviceOutage = props.propertyUtilities.data.propertyUtility?.serviceOutage;
      return serviceOutage === 1 || serviceOutage === true;
    }
  );

  const [serviceOuttageOrigin, setServiceOuttageOrigin] = React.useState(
    () => {
      const serviceOutage = props.propertyUtilities.data.propertyUtility?.serviceOutage;
      return serviceOutage === 1 || serviceOutage === true;
    }
  );

  const [active, setActive] = React.useState(() => {
    const activeValue = props.propertyUtilities.data.propertyUtility?.active;
    return activeValue === 1 || activeValue === true;
  });
  const [submitted, setSubmitted] = React.useState(false);
  // Explicit override from the datetime picker; null means "use default/now".
  const [outageReportedOverride, setOutageReportedOverride] = React.useState(null);

  useEffect(() => {
    if (props.propertyUtilities.data.propertyUtility) {
      const serviceOutage = props.propertyUtilities.data.propertyUtility.serviceOutage;
      const activeValue = props.propertyUtilities.data.propertyUtility.active;
      
      setServiceOuttage(serviceOutage === 1 || serviceOutage === true);
      setServiceOuttageOrigin(serviceOutage === 1 || serviceOutage === true);
      setActive(activeValue === 1 || activeValue === true);
    }
  }, [props.propertyUtilities.data.propertyUtility?.serviceOutage, props.propertyUtilities.data.propertyUtility?.active]);

  useEffect(() => {
    const ownersItems = props.owners.data.ownersList?.items;
    if (!ownersItems || ownersItems.length === 0) {
      if (!props.owners.isLoading) {
        props.getAllOwners();
      }
    }
    const vendorsItems = props.vendors.data.vendorsList?.items;
    if (!vendorsItems || vendorsItems.length === 0) {
      if (!props.vendors.isLoading) {
        props.getAllVendors();
      }
    }
  }, [props.owners.isLoading, props.vendors.isLoading, props.owners.data.ownersList?.items?.length, props.vendors.data.vendorsList?.items?.length]);

  const dispatch = useDispatch();

  const classes = useStyles();

  const AlertDialog = () => {
    let propertyUuid = props.match.params.uuid;
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    const handleUpdate = async () => {
      setOpen(false);
      await axios.put(
        `/serviceoutage/${props.properties.data.property.outage.uuid}`,
        { outageEnd: moment().format("YYYY-MM-DD HH:mm:ss") },
        {}
      );
      props.getPropertyByUuid(propertyUuid);
    };

    return (
      <div>
        <Button variant="outlined" onClick={handleClickOpen}>
          Confirm Outage Off?
        </Button>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm Outage complete?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to toggle this properties outage to OFF? If
              the notification setting is turned on, this will notify all active
              customers that the outage is not longer effecting their property.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>No</Button>
            <Button onClick={handleUpdate} autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const save = async () => {
    // Reset submitted state and validate required fields
    if (submitted) setSubmitted(false);
    
    let newPropertyUtil = props.propertyUtilities.data.propertyUtility;
    
    // Validate required fields
    if (!newPropertyUtil.vendorId) {
      setSubmitted(true);
      dispatch(
        setSnackbar(
          true,
          "error",
          "Please select a vendor before saving."
        )
      );
      return;
    }
    if (!newPropertyUtil.id) {
      await props.createUtilityRiderRate(newPropertyUtil);
    } else {
      const overriddenReportedAt = normalizeOutageReportedDate(
        outageReportedOverride
      );

      if (
        serviceOuttage &&
        props.propertyUtilities.data.propertyUtility.serviceOutage == 0
      ) {
        // Create a new service outage; honor override datetime when provided.
        let reportedAt =
          overriddenReportedAt || moment().format("YYYY-MM-DD HH:mm:ss");
        newPropertyUtil.outageReportedDate = reportedAt;
        try {
          await axios.post("/serviceOutage", {
            propertyUuid: props.properties.data.property.uuid,
            outageStart: reportedAt,
            outageReportedBy: props.user.details.id.toString(),
          });
          await props.getPropertyByUuid(props.properties.data.property.uuid);
          dispatch(
            setSnackbar(
              true,
              "success",
              `Service outage has been set at ${reportedAt}`
            )
          );
        } catch (e) {
          const alreadyExists =
            e &&
            e.response &&
            e.response.data &&
            e.response.data.ERROR === "OUTAGE_ALREADY_EXISTS";
          dispatch(
            setSnackbar(
              true,
              alreadyExists ? "success" : "error",
              alreadyExists
                ? `Service outage was already open; reported date synced`
                : "Unable to set a service outage. Try again later."
            )
          );
        }
      }
      if (
        !serviceOuttage &&
        props.propertyUtilities.data.propertyUtility.serviceOutage == 1
      ) {
        // The outage must be turned off
        try {
          let now = moment().format("YYYY-MM-DD HH:mm:ss");
          await axios.put(
            `/serviceoutage/${props.properties.data.property.outage.uuid}`,
            {
              outageEnd: now,
              outageClearedBy: props.user.details.id.toString(),
            }
          );
          newPropertyUtil.outageReportedDate = null;
          setOutageReportedOverride(null);
          await props.getPropertyByUuid(props.properties.data.property.uuid);
          dispatch(
            setSnackbar(true, "success", `Service outage has ended at ${now}`)
          );
        } catch (e) {
          dispatch(
            setSnackbar(
              true,
              "error",
              "Unable to set a turn off outage. Try again later."
            )
          );
        }
      }

      // While outage stays on, allow override of reported datetime and sync ServiceOutage.
      if (
        serviceOuttage &&
        props.propertyUtilities.data.propertyUtility.serviceOutage == 1 &&
        overriddenReportedAt
      ) {
        newPropertyUtil.outageReportedDate = overriddenReportedAt;
        const openOutageUuid =
          props.properties.data.property &&
          props.properties.data.property.outage &&
          props.properties.data.property.outage.uuid;
        if (openOutageUuid) {
          try {
            await axios.put(`/serviceoutage/${openOutageUuid}`, {
              outageStart: overriddenReportedAt,
            });
          } catch (e) {
            console.log("Unable to sync ServiceOutage.outageStart override", e);
          }
        }
      }

      let propUtil = {
        active: (newPropertyUtil.active === true || newPropertyUtil.active === 1) ? 1 : 0,
        customerInitiatedMoveIns: (newPropertyUtil.customerInitiatedMoveIns === true || newPropertyUtil.customerInitiatedMoveIns === 1) ? 1 : 0,
        customerInitiatedMoveOuts: (newPropertyUtil.customerInitiatedMoveOuts === true || newPropertyUtil.customerInitiatedMoveOuts === 1) ? 1 : 0,
        outageReportedDate: normalizeOutageReportedDate(
          newPropertyUtil.outageReportedDate
        ),
        serviceOutage: serviceOuttage ? 1 : 0,
        ownerId: newPropertyUtil.ownerId,
        vendorId: newPropertyUtil.vendorId,
        vendorAcctNum: newPropertyUtil.vendorAcctNum,
        lastBillDate: newPropertyUtil.lastBillDate,
        creditCardFee: newPropertyUtil.creditCardFee,
        utilCustomerCharge: newPropertyUtil.utilCustomerCharge,
        utilEnergyCharge: newPropertyUtil.utilEnergyCharge,
        contractRate: newPropertyUtil.contractRate,
        leaseLightFee: newPropertyUtil.leaseLightFee,
        EVMeterRate: newPropertyUtil.EVMeterRate,
        uuid: newPropertyUtil.uuid

      }

      await props.updateUtilityRiderRate(propUtil);
      const propertyId = newPropertyUtil.propertyId ||
                         newPropertyUtil.property?.id || 
                         props.properties.data.property?.id;
      if (propertyId) {
        await props.getPropertyUtility(propertyId);
      }
    }

    props.onUpdate();
  };

  if (
    props.owners.isLoading ||
    props.vendors.isLoading ||
    props.propertyUtilities.propertyUtilityIsLoading ||
    !props.propertyUtilities.data.propertyUtility
  ) {
    return (
      <Box sx={{ maxHeight: '80vh', overflow: 'auto', p: 3 }}>
        <Card elevation={0} sx={{ borderRadius: 2 }}>
          <CardContent sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 4 }}>
              {[...Array(4)].map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  width={180}
                  height={40}
                  sx={{ 
                    bgcolor: 'action.hover',
                    borderRadius: 1
                  }}
                />
              ))}
            </Box>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 4 }}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={56}
                sx={{ 
                  bgcolor: 'action.hover',
                  borderRadius: 1,
                  flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 12px)' }
                }}
              />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={56}
                sx={{ 
                  bgcolor: 'action.hover',
                  borderRadius: 1,
                  flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 12px)' }
                }}
              />
            </Box>

            {/* Loading Skeleton - Three Column Input Fields */}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 4 }}>
              {[...Array(3)].map((_, colIndex) => (
                <Box 
                  key={colIndex}
                  sx={{ 
                    flex: { xs: '1 1 100%', md: '1 1 calc(33.33% - 16px)' }, 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: 3 
                  }}
                >
                  {[...Array(3)].map((_, rowIndex) => (
                    <Skeleton
                      key={rowIndex}
                      variant="rectangular"
                      width="100%"
                      height={56}
                      sx={{ 
                        bgcolor: 'action.hover',
                        borderRadius: 1
                      }}
                    />
                  ))}
                </Box>
              ))}
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, pt: 3, borderTop: '1px solid', borderColor: 'divider' }}>
              <Skeleton
                variant="rectangular"
                width={100}
                height={40}
                sx={{ 
                  bgcolor: 'action.hover',
                  borderRadius: 1
                }}
              />
              <Skeleton
                variant="rectangular"
                width={100}
                height={40}
                sx={{ 
                  bgcolor: 'action.hover',
                  borderRadius: 1
                }}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return (
    <Box sx={{ maxHeight: '80vh', overflow: 'auto', p: 3 }}>
      <Card elevation={0} sx={{ borderRadius: 2 }}>
        <CardContent sx={{ p: 3 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Property billing settings. Vendor sets default rates; rider rates are managed on Property
            Rider Rates.
          </Typography>

          {/* Checkboxes Section */}
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 4 }}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={active}
                    onChange={toggleActive}
                    name="active"
                    color="primary"
                  />
                }
                label={
                  <Typography variant="body1" fontWeight={500}>
                    Active
                  </Typography>
                }
              />
            </FormGroup>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={serviceOuttage}
                    onChange={toggleServiceOuttage}
                    name="serviceOutage"
                    color="primary"
                  />
                }
                label={
                  <Typography variant="body1" fontWeight={500}>
                    Outage
                  </Typography>
                }
              />
              <FormHelperText sx={{ mt: 0.5, ml: 0, fontSize: '0.75rem', color: 'text.secondary' }}>
                By selecting this checkbox, you are reporting an outage at this property.
              </FormHelperText>
            </FormGroup>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.propertyUtilities.data.propertyUtility
                      .customerInitiatedMoveIns === 1}
                    onChange={toggleCustomerInitiatedMoveIn}
                    name="customerInitiatedMoveIns"
                    color="primary"
                  />
                }
                label={
                  <Typography variant="body1" fontWeight={500}>
                    Customer Initiated Move In
                  </Typography>
                }
              />
            </FormGroup>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.propertyUtilities.data.propertyUtility
                      .customerInitiatedMoveOuts === 1}
                    onChange={toggleCustomerInitiatedMoveOut}
                    name="customerInitiatedMoveOuts"
                    color="primary"
                  />
                }
                label={
                  <Typography variant="body1" fontWeight={500}>
                    Customer Initiated Move Out
                  </Typography>
                }
              />
            </FormGroup>
          </Box>

          {/* Outage Reported Date override */}
          {serviceOuttage && (
            <Box sx={{ mb: 4 }}>
              <TextField
                fullWidth
                label="Outage Reported (override)"
                type="datetime-local"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={onFieldChange}
                onBlur={onFieldExit}
                name="outageReportedDate"
                value={
                  outageReportedOverride !== null
                    ? outageReportedOverride
                    : toDateTimeLocalValue(
                        props.propertyUtilities.data.propertyUtility
                          .outageReportedDate,
                        props.propertyUtilities.data.propertyUtility
                          .defaultDateValue
                      )
                }
                helperText="Optional. Set/override the time shown on the public outages page."
              />
            </Box>
          )}

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 4 }}>
            <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 12px)' } }}>
              <FormControl fullWidth variant="outlined">
                <InputLabel id="owner-select-label">
                  Default Unit Owner
                </InputLabel>
                <Select
                  labelId="owner-select-label"
                  id="owner-select"
                  value={props.propertyUtilities.data.propertyUtility.ownerId || ""}
                  label="Default Unit Owner"
                  onChange={onFieldChange}
                  onBlur={onFieldExit}
                  name="ownerId"
                >
                  {(props.owners.data.ownersList?.items || []).map((owner) => (
                    <MenuItem key={owner.id} value={owner.id}>
                      {owner.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 12px)' } }}>
              <FormControl
                fullWidth
                variant="outlined"
                error={submitted && !props.propertyUtilities.data.propertyUtility.vendorId}
              >
                <InputLabel id="vendor-select-label">
                  Vendor
                </InputLabel>
                <Select
                  labelId="vendor-select-label"
                  id="vendor-select"
                  value={props.propertyUtilities.data.propertyUtility.vendorId || ""}
                  label="Vendor"
                  name="vendorId"
                  onChange={onFieldChange}
                  onBlur={onFieldExit}
                >
                  {(props.vendors.data.vendorsList?.items || [])
                    .filter(
                      (item) =>
                        !item.status ||
                        item.status === "Active" ||
                        item.id ===
                          props.propertyUtilities.data.propertyUtility.vendorId
                    )
                    .map((vendor) => (
                    <MenuItem key={vendor.id} value={vendor.id}>
                      {vendor.name}
                    </MenuItem>
                  ))}
                </Select>
                {submitted && !props.propertyUtilities.data.propertyUtility.vendorId ? (
                  <FormHelperText>Vendor is required.</FormHelperText>
                ) : (
                  <FormHelperText sx={{ mt: 0.5, fontSize: '0.75rem', color: 'text.secondary' }}>
                    Utility provider for this property&apos;s billing rates.
                  </FormHelperText>
                )}
              </FormControl>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, mb: 4 }}>
            <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(33.33% - 16px)' }, display: 'flex', flexDirection: 'column', gap: 3 }}>
              <TextField
                fullWidth
                label="Vendor Account Number"
                name="vendorAcctNum"
                onChange={onFieldChange}
                onBlur={onFieldExit}
                value={props.propertyUtilities.data.propertyUtility.vendorAcctNum || ""}
                variant="outlined"
              />
              <Box>
                <TextField
                  fullWidth
                  label="Credit Card Fee"
                  name="creditCardFee"
                  onChange={onFieldChange}
                  onBlur={onFieldExit}
                  value={props.propertyUtilities.data.propertyUtility.creditCardFee || ""}
                  variant="outlined"
                  type="number"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                />
                <FormHelperText sx={{ mt: 0.5, fontSize: '0.75rem', color: 'text.secondary' }}>
                  Customer portal payments only.
                </FormHelperText>
              </Box>
              <Box>
                <TextField
                  fullWidth
                  label="Contract Rate"
                  name="contractRate"
                  onChange={onFieldChange}
                  onBlur={onFieldExit}
                  value={props.propertyUtilities.data.propertyUtility.contractRate || ""}
                  variant="outlined"
                  type="number"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$/kWh</InputAdornment>,
                  }}
                />
                <FormHelperText sx={{ mt: 0.5, fontSize: '0.75rem', color: 'text.secondary' }}>
                  Minimum rate for common areas.
                </FormHelperText>
              </Box>
            </Box>

            <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(33.33% - 16px)' }, display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Box>
                <TextField
                  fullWidth
                  label="Utility Customer Charge"
                  name="utilCustomerCharge"
                  onChange={onFieldChange}
                  onBlur={onFieldExit}
                  value={props.propertyUtilities.data.propertyUtility.utilCustomerCharge || ""}
                  variant="outlined"
                  type="number"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                />
                <FormHelperText sx={{ mt: 0.5, fontSize: '0.75rem', color: 'text.secondary' }}>
                  Property fallback if vendor base charge is not set.
                </FormHelperText>
              </Box>
              <Box>
                <TextField
                  fullWidth
                  label="EV Meter Rate"
                  name="EVMeterRate"
                  onChange={onFieldChange}
                  onBlur={onFieldExit}
                  value={props.propertyUtilities.data.propertyUtility.EVMeterRate || ""}
                  variant="outlined"
                  type="number"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$/kWh</InputAdornment>,
                  }}
                />
                <FormHelperText sx={{ mt: 0.5, fontSize: '0.75rem', color: 'text.secondary' }}>
                  Rate for EV meters.
                </FormHelperText>
              </Box>
            </Box>

            <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(33.33% - 16px)' }, display: 'flex', flexDirection: 'column', gap: 3 }}>
              <TextField
                fullWidth
                label="Last Bill Date"
                name="lastBillDate"
                onChange={onFieldChange}
                onBlur={onFieldExit}
                value={txtBoxDateFormatter(props.propertyUtilities.data.propertyUtility.lastBillDate) || ""}
                variant="outlined"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <Box>
                <TextField
                  fullWidth
                  label="Utility Energy Charge"
                  name="utilEnergyCharge"
                  onChange={onFieldChange}
                  onBlur={onFieldExit}
                  value={props.propertyUtilities.data.propertyUtility.utilEnergyCharge || ""}
                  variant="outlined"
                  type="number"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$/kWh</InputAdornment>,
                  }}
                />
                <FormHelperText sx={{ mt: 0.5, fontSize: '0.75rem', color: 'text.secondary' }}>
                  Property fallback if vendor base charge is not set.
                </FormHelperText>
              </Box>
              <Box>
                <TextField
                  fullWidth
                  label="Lease Light Fee"
                  name="leaseLightFee"
                  onChange={onFieldChange}
                  onBlur={onFieldExit}
                  value={props.propertyUtilities.data.propertyUtility.leaseLightFee || ""}
                  variant="outlined"
                  type="number"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                />
                <FormHelperText sx={{ mt: 0.5, fontSize: '0.75rem', color: 'text.secondary' }}>
                  Lease-light units. # lights × $21.50.
                </FormHelperText>
              </Box>
            </Box>
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, pt: 3, borderTop: '1px solid', borderColor: 'divider' }}>
            <Button
              variant="outlined"
              onClick={props.onCancel}
              size="large"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={save}
              size="large"
              color="error"
            >
              Save
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

// Component Properties
PropertyUtilityForm.propTypes = {
  propertyUtilities: PropTypes.object.isRequired,
  owners: PropTypes.object.isRequired,
  vendors: PropTypes.object.isRequired,
  updateUtilityRiderRate: PropTypes.func.isRequired,
  createUtilityRiderRate: PropTypes.func.isRequired,
  getPropertyByUuid: PropTypes.func.isRequired,
  updatePropertyUtilityLocalState: PropTypes.func.isRequired,
  getPropertyUtility: PropTypes.func.isRequired,
  getAllOwners: PropTypes.func.isRequired,
  getAllVendors: PropTypes.func.isRequired,
};

function PropertyUtilityFormState(state) {
  return {
    propertyUtilities: state.propertyUtilities,
    owners: state.owners,
    vendors: state.vendors,
    user: state.user,
    properties: state.properties
  };
}

export default connect(PropertyUtilityFormState, {
  updateUtilityRiderRate,
  createUtilityRiderRate,
  getPropertyUtility,
  getPropertyByUuid,
  updatePropertyUtilityLocalState,
  getAllOwners,
  getAllVendors,
})(PropertyUtilityForm);
